import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { User, LogOut } from "lucide-react";
import Footer from "../components/layout/Footer";
import ProfileModal from "./settings/ProfileModal";
import "../styles/UserLayout.css";
import "../styles/AdminLayout.css"; // reuse header styles

const UserLayout = () => {
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || user.role !== "User") {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="user-layout">
      {/* ===== TOP BAR ===== */}
      <div className="admin-topbar">
        {/* LEFT */}
        <div className="topbar-left">
          <img
            src={require("../assets/image.png")}
            alt="JT Attorney Alliance"
            className="brand-logo"
            onClick={() => navigate("/user")}
            style={{ cursor: "pointer", width: 180, height: "auto", objectFit: "contain" }}
          />

          <button
            className={
              location.pathname === "/user" ? "tab-btn active" : "tab-btn"
            }
            onClick={() => navigate("/user")}
          >
            Draft Generator
          </button>
		  
		  <button
            className={
              location.pathname === "/user/alldrafts" ? "tab-btn active" : "tab-btn"
            }
            onClick={() => navigate("/user/alldrafts")}
          >
            All Drafts
          </button>

          {/* ❌ SETTINGS NOT SHOWN FOR USER */}
        </div>

        {/* RIGHT */}
        <div className="topbar-right">
          <button
            className="icon-btn"
            onClick={() => setShowProfile(true)}
            title="Profile"
          >
            <User size={20} />
          </button>

          <button
            className="icon-btn"
            title="Logout"
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>

      {/* ===== PAGE CONTENT ===== */}
      <div className="user-content">
        <Outlet />
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />

      {/* ===== PROFILE MODAL ===== */}
      {showProfile && (
        <ProfileModal onClose={() => setShowProfile(false)} />
      )}
    </div>
  );
};

export default UserLayout;
